import moment from 'moment'

/**
 * 格式化时间戳
 * 
 * @param {String} timeStamp 时间戳
 * @param {String} format 格式
 * @returns 时间字符串
 */
export function formatTimeStamp(timeStamp, format = 'YYYY-MM-DD HH:mm:ss') {
  if (timeStamp) {
    return moment(timeStamp).format(format)
  } else {
    return timeStamp
  }
}

/**
 * 把时间字符串转换为时间戳
 * 
 * @param {String} time 时间字符串(格式: YYYY-MM-DD HH:mm:ss)
 * @returns 时间戳
 */
export function toTimeStamp(time) {
  if (time) {
    return moment(time, 'YYYY-MM-DD HH:mm:ss').valueOf()
  } else {
    return time
  }
}
